export default function ({children}) {

    return <div className={'title'}>
        {children}
    </div>
}